@if (pending()) {
<!-- Backdrop -->
<div class="fixed inset-0 z-50 bg-black/70 backdrop-blur-xs transition-opacity duration-300 flex items-center justify-center p-4 sm:p-6 animate-in fade-in">
  <!-- Modal Card -->
  <div (click)="$event.stopPropagation()"
    class="w-full max-w-sm bg-surface rounded-2xl shadow-2xl border border-border overflow-hidden flex flex-col p-5 space-y-4 animate-in fade-in zoom-in-95 duration-200">
    <!-- Icon & Title -->
    <div class="flex flex-col items-center text-center space-y-2">
      <div class="w-12 h-12 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-600 flex items-center justify-center shadow-xs">
        <svg class="w-6 h-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
        </svg>
      </div>
      <h3 class="text-base font-bold text-main">
        {{ 'TABLE_SWITCH.TITLE' | translate }}
      </h3>
      <p class="text-xs text-muted leading-relaxed">
        {{ 'TABLE_SWITCH.MESSAGE' | translate }}
      </p>
    </div>

    <!-- Table Transition Box -->
    <div class="flex items-center justify-between p-3 rounded-xl bg-surface-hover/70 border border-border text-xs">
      <div class="flex flex-col items-start min-w-0 flex-1">
        <span class="text-[10px] uppercase font-bold text-muted tracking-wider">
          {{ 'TABLE_SWITCH.CURRENT_TABLE' | translate }}
        </span>
        <span class="font-bold text-main truncate max-w-[110px]">
          {{ currentTableName() }}
        </span>
      </div>

      <div class="px-2 text-muted shrink-0">
        <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
        </svg>
      </div>

      <div class="flex flex-col items-end min-w-0 flex-1 text-right">
        <span class="text-[10px] uppercase font-bold text-primary tracking-wider">
          {{ 'TABLE_SWITCH.NEW_TABLE' | translate }}
        </span>
        <span class="font-bold text-primary truncate max-w-[110px]">
          {{ newTableName() }}
        </span>
      </div>
    </div>

    <!-- Helpful Note -->
    <div class="p-2.5 rounded-xl bg-primary/5 border border-primary/15 text-[11px] text-muted flex items-start gap-2">
      <svg class="w-4 h-4 text-primary shrink-0 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round"
          d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
      </svg>
      <span class="leading-tight">
        {{ 'TABLE_SWITCH.NOTE' | translate }}
      </span>
    </div>

    <!-- Action Buttons -->
    <div class="flex flex-col gap-2 pt-1">
      <button type="button" (click)="confirm()"
        class="w-full py-2.5 px-4 rounded-xl bg-primary text-primary-contrast font-bold text-xs shadow-sm hover:opacity-90 active:scale-[0.98] transition-all cursor-pointer">
        {{ 'TABLE_SWITCH.CONFIRM' | translate }}
      </button>
      <button type="button" (click)="cancel()"
        class="w-full py-2.5 px-4 rounded-xl bg-surface-hover hover:bg-surface-hover/80 text-muted hover:text-main font-semibold text-xs transition-colors cursor-pointer">
        {{ 'TABLE_SWITCH.CANCEL' | translate }}
      </button>
    </div>
  </div>
</div>
}